export const ScanToPayEmptyStateIllustration = require('./scan-to-pay-empty-state-illustration.webp');
